module.exports = __webpack_public_path__ + "static/VineetaSingh.c0a94477.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/VineetaSingh.jpg
// module id = 249
// module chunks = 25111403944408 251948199435738